import { Sparkles } from "lucide-react";

export default function PromoBanner({ compact = false }) {
  return (
    <div className="relative overflow-hidden rounded-2xl bg-gradient-to-r from-indigo-600 via-indigo-700 to-cyan-600 p-4 sm:p-6" data-testid="promo-banner">
      <div className="absolute inset-0 mg-grid-bg opacity-20" />
      <div className="relative flex items-center justify-between gap-3">
        <div className="flex items-center gap-3 min-w-0">
          <div className="hidden sm:flex h-11 w-11 rounded-xl bg-white/20 items-center justify-center shrink-0">
            <Sparkles size={22} className="text-white" />
          </div>
          <div className="min-w-0">
            <p className="font-display font-extrabold text-white text-base sm:text-lg leading-tight">Offre de lancement 🎉</p>
            <p className="text-white/85 text-xs sm:text-sm">
              <span className="sm:hidden">-20% appliqués automatiquement au paiement.</span>
              <span className="hidden sm:inline">Profitez de <strong>20% de réduction</strong> sur votre abonnement, appliqués automatiquement au paiement{!compact && " — pendant 3 mois"}.</span>
            </p>
          </div>
        </div>
        <span className="shrink-0 px-3 py-1.5 sm:px-4 sm:py-2 rounded-xl bg-white text-indigo-700 font-display font-extrabold text-base sm:text-lg" data-testid="promo-badge">-20%</span>
      </div>
    </div>
  );
}
